
type IconProps = React.SVGProps<SVGSVGElement>

function IconBase(props: IconProps){
  const { className, ...rest } = props
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} {...rest}/>
}

export function LayoutDashboard(props: IconProps){
  return (
    <IconBase {...props}>
      <rect x="3" y="3" width="8" height="8" rx="1"></rect>
      <rect x="13" y="3" width="8" height="5" rx="1"></rect>
      <rect x="13" y="10" width="8" height="11" rx="1"></rect>
      <rect x="3" y="13" width="8" height="8" rx="1"></rect>
    </IconBase>
  )
}

export function Building2(props: IconProps){
  return (
    <IconBase {...props}>
      <rect x="4" y="3" width="16" height="18" rx="2"></rect>
      <path d="M9 7h2M13 7h2M9 11h2M13 11h2M7 21v-3h10v3"></path>
    </IconBase>
  )
}

export function ClipboardCheck(props: IconProps){
  return (
    <IconBase {...props}>
      <rect x="7" y="3" width="10" height="4" rx="1"></rect>
      <rect x="5" y="7" width="14" height="14" rx="2"></rect>
      <path d="M9 14l2 2 4-4"></path>
    </IconBase>
  )
}

export function Stethoscope(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M7 4v5a4 4 0 0 0 8 0V4"></path>
      <path d="M11 19a4 4 0 0 0 4-4v-3"></path>
      <circle cx="18.5" cy="12.5" r="2.5"></circle>
    </IconBase>
  )
}

export function GraduationCap(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M3 9l9-5 9 5-9 5-9-5z"></path>
      <path d="M21 10v6"></path>
      <path d="M12 14l-6-3v4.5A6.5 6.5 0 0 0 12 22a6.5 6.5 0 0 0 6-3.5V11"></path>
    </IconBase>
  )
}

export function Users(props: IconProps){
  return (
    <IconBase {...props}>
      <circle cx="9" cy="8" r="3"></circle>
      <circle cx="17" cy="10" r="3"></circle>
      <path d="M3 20a6 6 0 0 1 12 0"></path>
      <path d="M12 20a6 6 0 0 1 9 0"></path>
    </IconBase>
  )
}

export function FileText(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12"></path>
      <path d="M14 2v6h6"></path>
      <path d="M8 13h8M8 17h5"></path>
    </IconBase>
  )
}

export function BookOpen(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M2 4h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
      <path d="M22 4h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </IconBase>
  )
}

export function HeartHandshake(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M12 21s-6-4.35-9-7.5A5.5 5.5 0 0 1 12 5a5.5 5.5 0 0 1 9 8.5c-3 3.15-9 7.5-9 7.5z"></path>
      <path d="M8 14l2 2 2-2 2 2"></path>
    </IconBase>
  )
}

export function Sparkles(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M12 3l1.5 3 3 1.5-3 1.5-1.5 3-1.5-3L6 7.5 9 6z"></path>
      <path d="M18 13l.75 1.5L20 16l-1.25.5L18 18l-.75-1.5L16 16l1.25-.5z"></path>
    </IconBase>
  )
}

export function LibrarySparkles(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M4 5h6v14H4z"></path>
      <path d="M10 5h6v14h-6z"></path>
      <path d="M16 7h4v12h-4z"></path>
      <path d="M13 4l.9 1.8 1.8.9-1.8.9-.9 1.8-.9-1.8-1.8-.9 1.8-.9z"></path>
    </IconBase>
  )
}

export function TrendingUp(props: IconProps){
  return (
    <IconBase {...props}>
      <path d="M3 17l6-6 4 4 7-7"></path>
      <path d="M14 8h7v7"></path>
    </IconBase>
  )
}

export function HelpCircle(props: IconProps){
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="10"></circle>
      <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 2-2.5 2-2.5 4"></path>
      <path d="M12 17h.01"></path>
    </IconBase>
  )
}
